<template>
    <div>
        <div class="nav-box">
            <div class="left_nav_content">
                <img :src="logo" alt="">
                <div class="sys_name">
                    {{ collegeName }}
                </div>
                <el-dropdown v-if="isPhoneStyle">
                    <div class="iconfont icon-mulu phone-mulu"></div>
                <el-dropdown-menu class="drop-menu" slot="dropdown">
                    <el-dropdown-item v-for="(item,index) in navList" :key="index"  @click.native="toRoute(item)">{{ item.label }}</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div v-if="!isPhoneStyle" class="center_nav_content">
                <div v-for="(item, index) in navList" :key="index" @click="toRoute(item)">
                    <div class="center-item" v-if="item.show">
                        <div>{{ item.label }}</div>
                        <div class="active-label" v-if="currentNav == item.value"></div>
                    </div>
                </div>
            </div>
            <div class="right_nav_content" v-if="!$store.state.user.userInfo.loginName">
                <div @click="openPopup('login')">登录</div>
                <div>/</div>
                <div @click="openPopup('register')">注册</div>
            </div>
            <div v-else style="display: flex;align-items: center;">
                <!-- <el-badge :value="messageCount" :max="9" class="badge" :hidden="messageCount === 0">
                    <i class="el-icon-message-solid" style="font-size: 2.4rem;cursor: pointer" @click="openMessage"></i>
                </el-badge> -->
                <el-dropdown>
                    <div class="user">{{ $store.state.user.userInfo.userName || $store.state.user.userInfo.loginName}}</div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="isShowBackSys"
                            @click.native="intoMagSys">教学管理</el-dropdown-item>
                        <el-dropdown-item @click.native="changePassword">修改密码</el-dropdown-item>
                        <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <announcement v-if="$store.state.user.userInfo.loginName" ref="announce"></announcement>
    </div>
</template>

<script>
import { Logout } from '@/api/common/common';
import Utils from "@/assets/js/Utils";
import Announcement from '@/components/common/Announcement'
import common from "@/assets/js/common";
import { NAVLIST, deepClone } from '@/utils/utils';
export default {
    components: { Announcement },
    data() {
        return {
            logo: require('../../assets/image/logo2.png'),
            collegeName: '',
            isShow: false,
            dom: null
        }
    },
    methods: {
        handleClick(e) {
            console.log(e)
        },
        /**打开通知弹窗 */
        openMessage() {
            let dialog = this.$refs.announce;
            if (dialog) {
                dialog.dialogVisible = true;
                dialog.toGetMessage();
            }
        },
        /**进入后台系统 */
        intoMagSys() {
            var magSysList = this.$store.state.menu.magSysList;
            if (magSysList.length == 0) return;
            var origin = window.location.origin;
            window.open(origin + '/magSys/' + magSysList[0].value, '_blank');
            this.$store.commit('changeCurrentMagNav', magSysList[0]);
        },
        /**跳转导航 */
        toRoute(item) {
            this.$router.push(item.path);
        },
        /**打开弹窗 */
        openPopup(value) {
            this.$store.commit('changeGoLogin', value);
        },
        /**判断是否从院校中心进入 */
        isCollege() {
            this.$nextTick(() => {
                var tenantId = sessionStorage.getItem('institutionTenantId');
                var collegeName = sessionStorage.getItem('collegeName');
                var appName = this.$store.state.user.appDetail.appName || '';
                this.$store.commit('changeShowCollegeCenter', tenantId ? false : true);
                this.collegeName = tenantId ? collegeName : appName;
            })
        },
        /**退出登录 */
        logout() {
            this.$confirm('是否确认退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                Logout().then((res) => {
                    if (res) {
                        if(this.$route.path!='/'){
                            this.$router.push('/');
                        }else{
                            this.$store.commit('home/changeRouteAlive', false);
                            this.$nextTick(function () {
                                this.$store.commit('home/changeRouteAlive', true);
                            })
                        }
                        Utils.$emit('sys_logout');
                        this.$store.dispatch("removeToken");
                        var ws = this.$store.state.user.socketTimer.ws;
                        this.changeNav();
                        sessionStorage.clear();
                        this.$store.dispatch('clearSocket');
                        this.$store.commit('changePersonNavList', []);
                        this.$store.commit('set_permissions', []);
                        this.$store.commit('changeCurrentNav', '');
                        this.$store.commit('logoutAppInfo');
                        this.isCollege();
                        ws && ws.close();
                    }
                });
            }).catch(() => {
                console.log('no');
            });
        },
        /**修改密码 */
        changePassword() {
            this.$store.commit('changeGoLogin', 'replace');
        },
        /**导航渐变 */
        navGradient(element) {
            var stickyElement = document.querySelector('.nav-box');
            if (element) {
                const intersectionObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // 当stickyElement与其任何一个根(root)相交时，会进入此块
                            stickyElement.style.background = 'transparent';
                        } else {
                            stickyElement.style.background = '#000219';
                        }
                    });
                }, {
                    // 可以设置IntersectionObserver的选项，如阈值等
                    threshold: 0 // 当目标元素占据屏幕50%以上时，认为它是在视口中
                });
                // 开始观察stickyElement
                intersectionObserver.observe(element);
            }
        },
        /**检查导航 */
        changeNav() {
            let token = common.getCookie("token");
            let refreshToken = common.getCookie("refreshToken");
            if (!token && !refreshToken) {
                this.$store.commit('updateNavList', deepClone(NAVLIST));
                this.$store.commit('del_token');
            }
        },
        /**跳转路由回到顶部 */
        backTop() {
            if (!this.dom) {
                this.dom = document.querySelector('#app');
            }
            this.dom && this.dom.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth' // 可选，平滑滚动效果
            });
        },
        /**导航渐变 */
        changeNavColor(val) {
            var element = null;
            if (val.path == "/personCenter") {
                setTimeout(() => {
                    element = document.getElementById('banner-p');
                    this.navGradient(element);
                }, 10)
            } else if (val.path == "/") {
                var timer = setInterval(() => {
                    element = document.getElementById('banner-h');
                    this.navGradient(element);
                    if (element) clearInterval(timer);
                }, 10)
            } else if (val.path == "/course") {
                setTimeout(() => {
                    element = document.getElementById('banner-c');
                    this.navGradient(element);
                }, 10)
            } else if (["/virtualSimulation", '/examineVirtual'].includes(val.path)) {
                setTimeout(() => {
                    element = document.getElementById('banner-c');
                    this.navGradient(element);
                }, 10)
            }
        }
    },
    computed: {
         /**是否展示手机风格 */
        isPhoneStyle(){
            return this.$store.state.media.isPhoneStyle;
        },
        navList() {
            return this.$store.state.menu.navList;
        },
        /**当前所在导航页 */
        currentNav() {
            return this.$route.meta.permission;
        },
        /**后台菜单 */
        magSysList() {
            return this.$store.state.menu.magSysList;
        },
        /**未读消息数量 */
        messageCount() {
            return this.$store.state.notice.messageCount;
        },
        /**角色名称 */
        roleName(){
            let roleCode=this.$store.state.user.userInfo.roleCode;
            let accountType=this.$store.state.user.userInfo.accountType;
            if(accountType==1){
                if(roleCode=='global_001'){
                    return '师';
                }else if(roleCode=='global_002'){
                    return '学';
                }else{
                    return '无';
                }
            }else{
                return "管";
            }
        },
        /**后台权限判断 */
        isShowBackSys(){
            let roleCode=this.$store.state.user.userInfo.roleCode;
            let accountType=this.$store.state.user.userInfo.accountType;
            if(accountType!=1||roleCode=='global_001'){
                return true;
            }
            return false;
        },
    },
    mounted() {
        this.dom = document.querySelector('#app');
    },
    watch: {
        $route: {
            handler(val) {
                this.changeNav();
                this.isCollege();
                this.backTop();
                this.changeNavColor(val);
            }, immediate: true
        },
    },
}
</script>

<style lang="less" scoped>
.nav-box {
    padding: 2.7rem 4.5rem 1.5rem 4.5rem;
    height: 8.5rem;
    display: flex;
    justify-content: space-between;
    font-family: 'REGULAR' sans-serif;
    align-items: flex-start;
    position: fixed;
    background: #000219;
    width: 100%;
    z-index: 99;
    top: 0;

    .left_nav_content {
        display: flex;
        img {
            height: 4.4rem;
            object-fit: cover;
            margin-top: -0.5rem;
        }

        .sys_name {
            font-size: 1.8rem;
            color: #DCEFFF;
            margin-left: 1rem;
        }
    }

    .center_nav_content {
        display: flex;
        font-size: 16px;
        position: absolute;
        width: 100%;
        display: flex;
        justify-content: center;
        z-index: -1;

        &> :nth-child(n) {
            .center-item {
                margin-left: 5rem;
                cursor: pointer;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }

        &> :nth-child(1) {
            .center-item {
                margin-left: 0rem;
            }
        }

        .active-label {
            width: 18px;
            height: 2px;
            background: #1f8ceb;
            margin-top: 2rem;
        }
    }

    .right_nav_content {
        display: flex;
        font-size: 16px;

        &> :nth-child(1) {
            cursor: pointer;
            margin-right: 0.5rem;
        }

        &> :nth-child(3) {
            cursor: pointer;
            margin-left: 0.5rem;
        }
    }
}

.user {
    color: #ffffff;
    cursor: pointer;
}
.info-label{
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    border-radius: 50%;
    margin-left: 1rem;
    border: 2px solid #ffffff;
}
.phone-mulu{
        margin-left: 2rem;
        cursor: pointer;
        font-size: 2.5rem;
        color: #ffffff;
    }
.badge{
    margin-right: 2rem;
}
@media screen and (max-width:750px) {
    .nav-box{
        padding: 2.7rem 2rem 1.5rem 2rem;
    }
    .badge{
        margin-right: 0;
    }
    /deep/.el-dropdown-menu--small .el-dropdown-menu__item {
        font-size: 16px !important;
    }
}
</style>